import { useState, useEffect, useCallback } from 'react';
import { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { useSettingsContext } from '../useSettings';
import TourStepMapping from './tourSteps/TourStepMapping';
import { getNestedValue } from 'src/utils/settings';
import { TourChoiceComponent } from 'src/components/molecules/tour/TourChoiceComponent';

export const useTour = (tourName) => {
    const isMultipleTours = Array.isArray(tourName);
    const [selectedTour, setSelectedTour] = useState(isMultipleTours ? null : tourName);

    const [steps, setSteps] = useState(isMultipleTours ? getChoiceStep(tourName, setSelectedTour) : TourStepMapping[tourName]);
    const {settings, setSetting} = useSettingsContext();
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [eventListener, setEventListener] = useState(null);
    //console.log("Gettings settings for tour", tourName, settings, "using ", ["runtour", isMultipleTours ? tourName.join("-") : tourName]);
    //console.log("Test", settings?.["runtour"]?.[tourName])
    const [runTour, setRunTour] = useState(getNestedValue(settings, ["runtour", isMultipleTours ? tourName.join("-") : tourName], settings["runalltours"] ?? false));
    useEffect(() => {
        setRunTour(getNestedValue(settings, ["runtour", isMultipleTours ? tourName.join("-") : tourName], settings["runalltours"] ?? false));
    }
        , [settings]);
    useEffect(() => {
        if (selectedTour && isMultipleTours) {
            setSteps(TourStepMapping[selectedTour]);
            setRunTour(true);
        }
    }, [selectedTour]);
    useEffect(() => {
        setSetting( ["runtour", isMultipleTours ? tourName.join("-") : tourName], runTour)
        if (!runTour) {

        }
    }, [runTour])
    const restartTour = useCallback(() => {
        if (isMultipleTours) {
            setSelectedTour(null)
            setSteps(getChoiceStep(tourName, setSelectedTour));
        }
        setRunTour(false); // First, stop the tour
        setTimeout(() => setRunTour(true), 0); // Then, restart the tour immediately
    }, []);
    const advanceStep = useCallback(() => {
        setCurrentStepIndex(prevIndex => Math.min(prevIndex + 1, steps.length - 1));
    }, [steps]);
    const endTour = () => {
        if (eventListener) {
            const { targetElement, handleClick } = eventListener;
            targetElement.removeEventListener('click', handleClick);
            setEventListener(null);
        }
        setCurrentStepIndex(0);
        setRunTour(false);
    }

    const clickTarget = useCallback(() => {
        const currentStep = steps[currentStepIndex];
        if (currentStep && currentStep.spotlightClicks) {
            const targetElement = document.querySelector(currentStep.target);
            if (targetElement) {
                targetElement.click();
            }
        }
    }, [currentStepIndex, steps]);

    useEffect(() => {
        if (eventListener) {
            const { targetElement, handleClick } = eventListener;
            targetElement.removeEventListener('click', handleClick);
            setEventListener(null); // Resetting event listener state
        }
        const currentStep = steps[currentStepIndex];

        if (currentStep && currentStep.spotlightClicks) {
            const attemptAttachListener = () => {
                const targetElement = document.querySelector(currentStep.target);
                if (targetElement) {
                    const handleClick = () => {
                        setTimeout(advanceStep, 100); // Adjust the delay as necessary
                        // Remove the event listener after click
                        targetElement.removeEventListener('click', handleClick);
                        setEventListener(null); // Resetting event listener state
                    };
                    targetElement.addEventListener('click', handleClick);
                    // Saving the event listener in the state for later removal
                    setEventListener({ targetElement, handleClick });
                    return () => targetElement.removeEventListener('click', handleClick);
                }
                return false;
            };

            // Try to attach the listener right away. If unsuccessful, retry after a short delay.
            if (!attemptAttachListener()) {
                const retryId = setTimeout(attemptAttachListener, 500);
                return () => clearTimeout(retryId);
            }

            return () => {
                if (eventListener) {
                    const { targetElement, handleClick } = eventListener;
                    targetElement.removeEventListener('click', handleClick);
                    setEventListener(null);
                }

            };
        }
    }, [currentStepIndex, steps, advanceStep]);

    const handleJoyrideCallback = useCallback((data) => {
        const { status, action, index, type } = data;
        const STATUS_FINISHED_SKIPPED = [STATUS.FINISHED, STATUS.SKIPPED];
        const ACTIONS_NEXT_PREV = [ACTIONS.NEXT, ACTIONS.PREV];
        const EVENTS_STEP_AFTER_TARGET_NOT_FOUND = [EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND];
        if (STATUS_FINISHED_SKIPPED.includes(status) || action === ACTIONS.CLOSE || action === ACTIONS.STOP) {
            endTour();
        } else if (ACTIONS_NEXT_PREV.includes(action)) {
            if (EVENTS_STEP_AFTER_TARGET_NOT_FOUND.includes(type)) {
                if (action === ACTIONS.NEXT) {
                    if (index < steps.length - 1) {

                        const currentStep = steps[index];
                        if (currentStep && currentStep.spotlightClicks) {
                            clickTarget();
                        } else {
                            advanceStep();
                        }
                    } else {
                        endTour();
                    }
                } else {
                    setCurrentStepIndex(index - 1);

                }
            }

        }
    }, [clickTarget]);

    return {
        steps,
        runTour,
        currentStepIndex,
        restartTour,
        handleJoyrideCallback,
    };
};


const getChoiceStep = (tourName, setSelectedTour) => {
    return [{
        target: '#root',
        placement: 'center',
        disableBeacon: true,
        content: <TourChoiceComponent
            choices={tourName.map(name => ({ label: name, value: name }))}
            setSelectedTour={setSelectedTour}
        />,
        title: 'Choose Your Tour',
        // choices: tourName.map(name => ({ label: name, value: name })),
    }]
}

export default useTour;
